<template>
    <label :for="id + '_button'" :class="{'active': isActive}" class="toggle__button">

        <span class="toggle__label before">{{ titleText }}</span>
        <input type="checkbox" :disabled="disabled" :id="id + '_button'" v-model="checkedValue">
        <span v-if="isActive" class="toggle__label after">{{ enableText }}</span>
        <span v-if="! isActive" class="toggle__label after">{{ disabledText }}</span>

        <span class="toggle__switch"></span>
    </label>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },

        labelEnableText: {
            type: String,
            default: 'On'
        },
        labelTitleText: {
            type: String,
            default: 'units'
        },

        labelDisableText: {
            type: String,
            default: 'Off'
        },

        id: {
            type: String,
            default: 'primary'
        },

        defaultState: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            currentState: this.defaultState
        }
    },

    watch: {
        defaultState: function defaultState() {
            this.currentState = Boolean(this.defaultState)
        }
    },

    computed: {
        // currentState() {
        //     return this.defaultState;
        // },

        isActive() {
            return this.currentState;
        },

        enableText() {
            return this.labelEnableText;
        },
        titleText() {
          return this.labelTitleText;
        },

        disabledText() {
            return this.labelDisableText;
        },

        checkedValue: {
            get() {
                return this.currentState;
            },

            set(newValue) {
                this.currentState = newValue;
                this.$emit('change', newValue);
            }
        }
    }
}
</script>

<style scoped lang="scss">
$offcolor: #0E5064;
$oncolor: #fc9628;
.toggle__button {
    vertical-align: middle;
    user-select: none;
    cursor: pointer;
    position: relative;

    .toggle__label {
      &.before {
        position: absolute;
        left: -35px;
      }
      &.after {
        position: absolute;
        right: -30px;
      }
    }
}
.toggle__button input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    width: 1px;
    height: 1px;
}
.toggle__button .toggle__switch {
    display:inline-block;
    height:12px;
    border-radius:6px;
    width:40px;
    background: lighten($offcolor, 10%);
    box-shadow: inset 0 0 1px #BFCBD9;
    position:relative;
    margin-left: 10px;
    transition: all .25s;
}

.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
    content: "";
    position: absolute;
    display: block;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    left: 0;
    top: -3px;
    transform: translateX(0);
    transition: all .25s cubic-bezier(.5, -.6, .5, 1.6);
}

.toggle__button .toggle__switch::after {
    background: $offcolor;
    box-shadow: 0 0 1px #666;
}
.toggle__button .toggle__switch::before {
    background: $offcolor;
    box-shadow: 0 0 0 3px rgba(0,0,0,0.1);
    opacity:0;
}

.active .toggle__switch {
    background: lighten($oncolor, 10%);
    box-shadow: inset 0 0 1px #adedcb;
}

.active .toggle__switch::after,
.active .toggle__switch::before{
    transform:translateX(40px - 18px);
}

.active .toggle__switch::after {
    left: 5px;
    background: $oncolor;
    box-shadow: 0 0 1px $oncolor;
}
</style>
